import React from 'react';
import { lazy } from 'react';

// oya.souluapp.com 独立路由表，业务路由后续在此补充
const Home = lazy(() => import('./pages/home'));
const PrivacyPolicyBobo = lazy(() => import('./pages/privacyPolicyBobo'));
const TermsAndConditionsBobos = lazy(() => import('./pages/terms&ConditionsBobo'));
const ChildrenPolicys = lazy(() => import('./pages/childrenPolicy'));
const Abouts = lazy(() => import('./pages/about'));
const ContactUs = lazy(() => import('./pages/contactUs'));

const oyaRoutes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/oya',
    element: <Home />,
  },
  {
    path: '/oya.html',
    element: <Home />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyBobo />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsAndConditionsBobos />,
  },
  {
    path: '/children-policy',
    element: <ChildrenPolicys />,
  },
  {
    path: '/contact-us',
    element: <ContactUs />,
  },
  {
    path: '/oya-about',
    element: <Abouts />,
  },
];

export default oyaRoutes;
